import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ThemeMode, ThemeModeHelper } from '@shared/helpers/ThemeModeHelper';
import {UpdateThemeDto, UserServiceProxy} from '@shared/service-proxies/service-proxies';
@Component({
    standalone: false,
    selector: 'theme-mode-toggle',
    templateUrl: './theme-mode-toggle.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ThemeModeToggleComponent {
     public constructor(
            private _userService: UserServiceProxy
           
        ) {
        }
    @Input() customStyle = 'btn btn-icon btn-dropdown btn-clean mr-1 mt-0';

    mode: ThemeMode = ThemeModeHelper.applyThemeMode();

    get isDarkMode(): boolean {
        return this.mode === 'dark';
    }

    get toggleLabel(): string {
        return this.isDarkMode ? 'Switch to Light Mode' : 'Switch to Dark Mode';
    }

    toggleThemeMode(): void {
        this.mode = ThemeModeHelper.toggleMode();
        this._userService.updateTheme(new UpdateThemeDto({
            themeMode: this.mode== 'dark' ? 0:1
        })).subscribe();
    }
}
